import { rio } from '@amzn/rio-design-tokens';
import styled from '@emotion/styled';
// The color of this component is meant to correspond to the Meridian warning alert.
// We should keep in mind that the Meridian alert color can change at anytime without notice.
// Eventually we will have our own suite of custom styling on Meridian alerts, at which point
// this should be updated to match.
export const ErrorBar = styled.div `
  background-color: ${rio.base.color.yellow[60]};
  height: auto;
  width: 4px;
`;
